export const GET_MOVIE_DETAILS="GET_MOVIE_DETAILS";
export const LOADING_MOVIE_DETAILS="LOADING_MOVIE_DETAILS";
export const ERROR_MOVIE_DETAILS="ERROR_MOVIE_DETAILS";


export const GET_POPULAR_MOVIE="GET_POPULAR_MOVIE";
export const LOADING_POPULAR_MOVIE="LOADING_POPULAR_MOVIE";
export const ERROR_POPULAR_MOVIE="ERROR_POPULAR_MOVIE";

export const GET_FILTERED_DATA="GET_FILTERED_DATA"